module.exports = __webpack_public_path__ + "static/media/bnp-neolink.1adf6394.png";